import { combineReducers } from "redux";
import headerBar from "./headerBar";
import leftSideMenu from "./leftSideMenu";
import revisionPrice from "./revisionPrice";

export default combineReducers({
  headerBar,
  leftSideMenu,
  revisionPrice,
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js